import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'single-phone-component',
  templateUrl: './single.phone.component.html'
})
export class SinglePhoneComponent implements OnInit, OnDestroy {
  @Output() add = new EventEmitter<any>();
  @Output() subtract = new EventEmitter<any>();
  @Input() phoneChild:number;
  @Input() value:any;
  @Input() disabled:boolean;

  validationMessages: any;
  questionid:number;
  formErrors:any;
  formSegment:FormGroup;

  public getValue(){
    if(!this.disabled) {
      return this.formSegment.value;
    }
    return null;
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return !this.formSegment.controls['phoneNumber'].errors;
  }
  validate():boolean {
    this.formSegment.controls['phoneNumber'].markAsTouched();
    return this.isValid();
  }

  get formError():string {
    var err;

    if((this.formSegment.controls['phoneNumber'].dirty || this.formSegment.controls['phoneNumber'].touched) && !this.disabled) {
      err=this.formSegment.controls['phoneNumber'].errors;
      if(!!err){
        if(!!err.required) {
          return 'This answer is required.';
        }
        if(!!err.pattern) {
          return 'Please enter the phone number in the format (###) ###-####.';
        }
      }
    }
    return '';
  }

  onAdd(){
    this.add.emit(this.value.phoneChild);
  }

  onSubtract(){
    this.subtract.emit(this.value.phoneChild);
  }

  constructor() {
  }

  ngOnInit() {
    var init={};
    init['phoneNumber']=new FormControl(this.value.phoneNumber,[Validators.required,Validators.pattern(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/)]);
    init['phoneType']=new FormControl(this.value.phoneType);

    this.formSegment=new FormGroup(init);
  }

  ngOnDestroy() {
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/single.phone.component.ts